<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

      <a-form-model-item :label="this.$t('秒杀库存.时间轴id')" prop="seckillTimeId" >
          <a-select  style="width: 100%" v-model="form.seckillTimeId" placeholder="请选择时间轴" allowClear>
            <a-select-option  v-for="seckillTime in seckillList" @click="setAcTime(seckillTime)" :value="seckillTime.id">
              {{seckillTime.acName}}{{":"}}{{ seckillTime.startTime}}{{"-"}}{{ seckillTime.endTime }}
            </a-select-option>
          </a-select>
      </a-form-model-item>

      <a-form-model-item prop="shopIds" >
        <span slot="label" >
          <a-tooltip>
            参与门店<template slot="title">参与秒杀活动的门店，用户通过该门店购买会扣减该门店的库存</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.shopIds" mode="multiple" placeholder="请选择门店" :disabled="formType === 2" show-search :filter-option="filterOption">
          <a-select-option v-for="item in shopList" :key="item.id" :value="item.id">
            {{ item.shopName }}
          </a-select-option>
        </a-select>
        <span v-if="formType === 2" style="color: #999; font-size: 12px; display: block; margin-top: 4px;">修改活动时门店不可更改</span>
      </a-form-model-item>


      <a-form-model-item :label="$t('优惠券类型.有效日期开始时间')" prop="startTime">
        <a-date-picker v-model="form.startTime" valueFormat='YYYY-MM-DD' show-date
                       :placeholder="$t('优惠券类型.有效日期开始时间')"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('优惠券类型.有效日期结束时间')" prop="endTime">
        <a-date-picker v-model="form.endTime" valueFormat='YYYY-MM-DD' show-date
                       :placeholder="$t('优惠券类型.有效日期结束时间')"/>
      </a-form-model-item>
      <a-form-model-item label="最大购买数量" prop="maxBuyCount">
        <a-input-number
          v-model="form.maxBuyCount"
          :min="0"
          :precision="0"
          :placeholder="'请输入最大购买数量，0表示不限购'"
          style="width: 100%"
        />
        <span style="color: #999; font-size: 12px;">设置为0表示不限购</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('通用.文本.选择商品')" prop="goodsId">
        <a-button type="dashed" @click="openProdSelect" :disabled="formType === 2" danger>
          <span style="color: dodgerblue"> {{$t('通用.文本.选择商品')}}</span>
        </a-button>
      </a-form-model-item>

      <!-- 商品信息展示 -->
      <a-row>
        <a-col :span="24">
          <a-table
            v-if="form.goodsList.length > 0"
            :loading="goodsLoading"
            rowKey="id"
            :size="tableSize"
            :columns="goodsColumns"
            :data-source="form.goodsList"
            :pagination="false"
            :bordered="tableBordered"
            style="margin-bottom: 20px; width: 80%;">
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <template slot="picture" slot-scope="text, record">
              <div>
                <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
              </div>
            </template>
            <span slot="categoryId" slot-scope="text, record">
                {{getCategoryNameById(record.categoryId)}}
            </span>
            <span slot="brandId" slot-scope="text, record">
                 {{getBrandNameById(record.brandId)}}
              </span>
            <span slot="status" slot-scope="text, record">
               <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
              </span>
          </a-table>
        </a-col>
      </a-row>

      <!-- SKU秒杀价格设置 -->
      <a-row v-if="form.goodsId">
        <a-col :span="24">
          <div style="margin-bottom: 10px; font-weight: bold;">SKU秒杀价格设置</div>
          <template v-if="skuList && skuList.length > 0">
            <a-alert message="请为每个SKU设置秒杀价格和秒杀库存，秒杀库存将从可用库存中扣除，活动结束后未使用的库存会自动退还" type="info" style="margin-bottom: 10px;" show-icon />
            <a-table
              :loading="goodsLoading"
              rowKey="id"
              :size="tableSize"
              :columns="skuColumns"
              :data-source="skuList"
              :pagination="false"
              :bordered="tableBordered"
              style="width: 80%"
            >
              <template slot="picture" slot-scope="text, record">
                <div>
                  <img v-if="record.picture" :src="record.picture" style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                </div>
              </template>
              <template slot="seckillPrice" slot-scope="text, record">
                <a-input-number
                  v-model="record.seckillPrice"
                  :min="0"
                  :precision="2"
                  :placeholder="'请输入秒杀价'"
                  style="width: 100%"
                />
              </template>
              <template slot="skuStock" slot-scope="text, record">
                <span>{{ record.stock || 0 }}</span>
              </template>
              <template slot="seckillStock" slot-scope="text, record">
                <a-input-number
                  v-model="record.seckillStock"
                  :min="0"
                  :precision="0"
                  :placeholder="'请输入秒杀库存'"
                  style="width: 100%"
                />
              </template>
            </a-table>
          </template>
          <a-alert v-else message="请先选择商品" type="warning" />
        </a-col>
      </a-row>







      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
      <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSeckill, addSeckill, updateSeckill } from '@/api/zb/seckill'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import {listSeckillTime} from "@/api/seckill/seckillTime";
import RadioGoodsSelectForm from "@/views/zb/seckill/modules/RadioSelectForm";
import {listCategory} from "@/api/goods/category";
import {allBrand} from "@/api/goods/brand";
import {listByMerchantId, listShop} from '@/api/shop/shop'
import { getGoods, querySkuByGoodsId } from '@/api/goods/goods'


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    RadioGoodsSelectForm,
  },
  data () {
    return {
      goodsLoading: false,
      shopList: [], // 门店列表
      categoryList: [], // 分类列表
      brandList: [], // 品牌列表

      seckillList: [],//时间轴List
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      skuList: [], // 商品SKU列表
      goodsColumns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 120,
        },
        {
          title: '商品主图',
          dataIndex: 'picture',
          width: 70,
          scopedSlots: {customRender: 'picture'},
        },
        // {
        //   title: '市场价',
        //   width: 80,
        //   dataIndex: 'marketPrice',
        // },
        {
          title: '商品价',
          width: 80,
          dataIndex: 'price',
        },
      ],
      skuColumns: [
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 100,
          ellipsis: true
        },
        {
          title: 'SKU图片',
          dataIndex: 'picture',
          width: 60,
          align: 'center',
          scopedSlots: {customRender: 'picture'},
        },
        // {
        //   title: '原价',
        //   dataIndex: 'price',
        //   width: 70,
        //   align: 'center'
        // },
        // {
        //   title: '可用库存',
        //   dataIndex: 'stock',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: {customRender: 'skuStock'},
        // },
        {
          title: '秒杀库存',
          dataIndex: 'seckillStock',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'seckillStock'},
        },
        {
          title: '秒杀价',
          dataIndex: 'seckillPrice',
          width: 110,
          align: 'center',
          scopedSlots: {customRender: 'seckillPrice'},
        },
      ],
      // 表单参数
      form: {
        id: null,
        goodsList: [],
        skuList: [], // SKU列表及秒杀价

        seckillList: [],//时间轴List
        auditPage: false,
        seckillTimeId: null,

        goodsId: null,

        goodsName: null,

        seckillPrice: null,

        goodsPrice: null,

        seckillNum: null,

        goodsPicture: null,

        stock: null,

        shopId: null,
        shopIds: [],

        shopName: null,

        checkStatus: '0',

        complete: null,

        refuseReason: null,

        startTime: null,

        endTime: null,

        maxBuyCount: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        seckillTimeId: [
          { required: true, message: '请选择时间轴', trigger: 'change' }
        ],
        shopIds: [
          { required: true, message: '请选择门店', trigger: 'change', type: 'array' }
        ],
        startTime: [
          { required: true, message: '请选择有效日期开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择有效日期结束时间', trigger: 'change' }
        ],
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
        goodsName: [
          { required: true, message: this.$t('秒杀库存.商品名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        stock: [
          { required: true, message: this.$t('秒杀库存.秒杀商品库存')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        checkStatus: [
          { required: true, message: this.$t('秒杀库存.状态： 1：待审核   2：审核失败  3：审核成功,4:过期未审核  5：活动已结束')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        maxBuyCount: [
          { type: 'number', message: '最大购买数量必须是数字', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getSecKillTimeListValue();
    this.getCateList();
    this.getBrandList();
    this.getShopList();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    setAcTime(value) {
      // this.form.startTime=value.startTime
      // this.form.endTime=value.endTime

    },
    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
        const cate = { id: "0", categoryName: this.$t('通用.文本.根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id','pid')
        this.cateOptions.push(cate)
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getShopList() {
        // 商家角色,获取该商家名下的所有门店
      listByMerchantId().then(response => {
        this.shopList = response.data || []
      }).catch(() => {
        this.shopList = []
      })

    },
    handleShopChange(value) {
      // 门店改变时,清空已选择的商品和SKU
      if (this.form.goodsId) {
        this.form.goodsId = null
        this.form.goodsList = []
        this.skuList = []
      }
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        goodsList: [],
        id: null,
        seckillList: [],//时间轴List
        seckillTimeId: null,
        shopId: null,
        shopIds: [],
        goodsId: null,
        goodsName: null,
        seckillPrice: null,
        goodsPrice: null,
        seckillNum: null,
        goodsPicture: null,
        stock: null,
        shopName: null,
        checkStatus: '0',
        complete: null,
        refuseReason: null,
        startTime: null,
        endTime: null,
        maxBuyCount: null,
        createTime: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSeckill({"id":id}).then(response => {
        this.form = response.data
        // 确保shopIds是数组格式
        if (!this.form.shopIds) {
          this.form.shopIds = []
        } else if (typeof this.form.shopIds === 'string') {
          this.form.shopIds = this.form.shopIds.split(',').filter(id => id).map(id => parseInt(id))
        }
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
        // 加载商品SKU列表
        if (response.data.goodsId) {
          // 保存后端返回的秒杀价和秒杀库存数据，用于回填
          const skuPriceList = response.data.skuList || []
          this.loadGoodsSku(response.data.goodsId, skuPriceList)
        }
      })
    },
    getSecKillTimeListValue() {
      var that = this;
      listSeckillTime().then((response) => {
        this.seckillList = response.data;
      })
    },
    indexGoodsModalSelect(records) {
      this.form.goodsId = records[0].id
      this.form.goodsList = records
      console.log('商品选择了',this.form.goodsList)
      // 加载商品SKU列表
      this.loadGoodsSku(records[0].id)
    },
    openProdSelect() {
      // 查询平台商品 (shopId = 0)
      console.log('打开商品选择框,单选模式,查询平台商品')
      this.$refs.RadioGoodsSelectForm.openGoods(0, [this.form.goodsId]);
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 校验SKU秒杀价
          if (!this.skuList || this.skuList.length === 0) {
            this.$message.warning('请选择商品')
            return
          }
          const hasEmptySeckillPrice = this.skuList.some(sku => !sku.seckillPrice || sku.seckillPrice <= 0)
          if (hasEmptySeckillPrice) {
            this.$message.warning('请为所有SKU设置秒杀价')
            return
          }

          // 校验SKU秒杀库存
          const hasEmptySeckillStock = this.skuList.some(sku => sku.seckillStock == null || sku.seckillStock === '')
          if (hasEmptySeckillStock) {
            this.$message.warning('请为所有SKU设置秒杀库存')
            return
          }

          // 校验秒杀库存不能超过可用库存
          // const hasOverStock = this.skuList.some(sku => sku.seckillStock > sku.stock)
          // if (hasOverStock) {
          //   this.$message.warning('秒杀库存不能超过可用库存')
          //   return
          // }

          // 将SKU列表添加到表单数据中
          this.form.skuList = this.skuList.map(sku => ({
            skuId: sku.id,
            seckillPrice: sku.seckillPrice,
            seckillStock: sku.seckillStock
          }))

          // 计算最低秒杀价
          let minSeckillPrice = null
          this.skuList.forEach(sku => {
            if (sku.seckillPrice && sku.seckillPrice > 0) {
              if (minSeckillPrice === null || sku.seckillPrice < minSeckillPrice) {
                minSeckillPrice = sku.seckillPrice
              }
            }
          })
          this.form.seckillPrice = minSeckillPrice // 设置最低秒杀价

          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateSeckill(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addSeckill(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    loadGoodsSku(goodsId, skuPriceList) {
      console.log('开始加载SKU列表, goodsId:', goodsId, 'skuPriceList:', skuPriceList)
      if (!goodsId) {
        this.skuList = []
        this.goodsLoading = false
        return
      }
      this.goodsLoading = true

      // 并行加载SKU列表和商品详情
      Promise.all([
        querySkuByGoodsId(goodsId),
        getGoods({ id: goodsId })
      ]).then(([skuResponse, goodsResponse]) => {
        console.log('获取SKU列表成功:', skuResponse.data)
        console.log('获取商品详情成功:', goodsResponse.data)

        const skuList = skuResponse.data || []
        const goodsDetail = goodsResponse.data || {}
        const specList = goodsDetail.specList || []

        // 创建规格值ID到规格名称的映射
        const specValueMap = {}
        specList.forEach(spec => {
          if (spec.specValueList) {
            spec.specValueList.forEach(specValue => {
              specValueMap[specValue.id] = {
                specName: spec.specName,
                specValueName: specValue.specValueName
              }
            })
          }
        })
        console.log('规格值映射:', specValueMap)

        this.skuList = skuList.map(sku => {
          // 解析specValueIds (格式可能是 "id1:id2:id3")
          let skuName = sku.skuName || ''
          if (sku.specValueIds) {
            const specValueIdArray = sku.specValueIds.split(':')
            const specNameArray = []
            specValueIdArray.forEach(id => {
              const specInfo = specValueMap[id]
              if (specInfo) {
                specNameArray.push(`${specInfo.specName}:${specInfo.specValueName}`)
              }
            })
            if (specNameArray.length > 0) {
              skuName = specNameArray.join(' ')
            }
          }

          // 直接使用SKU数据中的秒杀价和秒杀库存（后端queryByGoodId已返回这些字段）
          let seckillPrice = sku.seckillPrice
          let seckillStock = sku.seckillStock

          // 如果有传入skuPriceList（修改时），则用它来补充/覆盖
          if (skuPriceList && skuPriceList.length > 0) {
            const priceItem = skuPriceList.find(item => item.skuId === sku.id)
            if (priceItem) {
              if (priceItem.seckillPrice !== null && priceItem.seckillPrice !== undefined) {
                seckillPrice = priceItem.seckillPrice
              }
              if (priceItem.seckillStock !== null && priceItem.seckillStock !== undefined) {
                seckillStock = priceItem.seckillStock
              }
            }
          }

          return {
            id: sku.id,
            skuId: sku.id,
            skuName: skuName,
            specValueIds: sku.specValueIds || '',
            picture: sku.picture || '',
            price: sku.price || 0,
            stock: sku.stock || 0,
            seckillPrice: seckillPrice,
            seckillStock: seckillStock
          }
        })
        console.log('SKU处理后数据:', this.skuList)
      }).catch(error => {
        console.error('加载SKU列表失败:', error)
        this.skuList = []
      }).finally(() => {
        this.goodsLoading = false
      })
    },

    //下拉框搜索过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

  }
}
</script>
